import type { AccessMode, OrganizationSummary, RestrictedOrganization } from "../api/contract";

// Product entitlement and organization-management authority are INDEPENDENT axes.
// `accessMode` is the server's own reconciliation of the two and is the only value the
// UI branches on — never `role` and never `productEntitled` alone:
//
//   licensed    → seated: product + whatever management the role allows
//   management  → unseated owner/admin: full management UI, no product access
//   unlicensed  → unseated ordinary member: nothing but the unlicensed notice
//
// See packages/auth `featuresForRole` for the matching feature projection.

export function accessMode(org: OrganizationSummary | undefined | null): AccessMode | null {
  return org?.accessMode ?? null;
}

/** Seated: the signed-in user may use the product in this organization. */
export function isProductEntitled(org: OrganizationSummary | undefined | null): boolean {
  return org?.productEntitled ?? false;
}

/** Unseated owner/admin — keeps organization management, loses product access. */
export function isManagementOnly(org: OrganizationSummary | undefined | null): boolean {
  return org?.accessMode === "management";
}

/** Unseated ordinary member — the unlicensed dead end. */
export function isUnlicensedMember(org: OrganizationSummary | undefined | null): boolean {
  return org?.accessMode === "unlicensed";
}

export function findRestricted(
  restricted: readonly RestrictedOrganization[],
  orgId: string
): RestrictedOrganization | null {
  return restricted.find((entry) => entry.id === orgId) ?? null;
}

/** Support address used by every lockout/denial recovery path. */
export const SUPPORT_EMAIL = "support@epidev.ai";
